import { updatesData } from '@/mocks/homeData';

const typeIconMap: Record<string, string> = {
  '线路': 'ri-link',
  '站点': 'ri-global-line',
  '安全': 'ri-shield-check-line',
  '功能': 'ri-tools-line',
};

const typeColorMap: Record<string, string> = {
  '线路': 'bg-primary-100 text-primary-700',
  '站点': 'bg-accent-100 text-accent-700',
  '安全': 'bg-secondary-100 text-secondary-700',
  '功能': 'bg-background-200 text-foreground-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs font-semibold text-secondary-500 uppercase tracking-wider mb-2">LATEST UPDATES</p>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900">最新动态</h2>
          <p className="text-sm text-foreground-600 mt-3 max-w-lg mx-auto">
            吃瓜网站线路更新与站点公告实时同步，随时掌握最新变化
          </p>
        </div>

        <div className="max-w-3xl mx-auto relative">
          <div className="absolute left-[19px] top-3 bottom-3 w-px bg-background-200"></div>

          <div className="space-y-0">
            {updatesData.map((item, i) => (
              <div key={i} className="flex gap-4 py-4 relative">
                <div className={`w-[38px] h-[38px] rounded-full flex items-center justify-center flex-shrink-0 z-10 ${
                  i === 0 ? 'bg-primary-500 text-white' : 'bg-background-100 text-foreground-500'
                }`}>
                  <i className={`text-sm ${i === 0 ? typeIconMap[item.type] || 'ri-notification-line' : 'ri-circle-fill'}`}></i>
                </div>

                <div className="flex-1 min-w-0 pt-1">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className={`text-[10px] font-semibold px-2 py-0.5 rounded ${typeColorMap[item.type] || 'bg-background-100 text-foreground-600'}`}>
                      {item.type}
                    </span>
                    <span className="text-xs text-foreground-500">{item.date} {item.time}</span>
                  </div>
                  <p className="text-sm text-foreground-800 leading-relaxed">{item.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}